import Home from "./screens/Home";
import Books from "./screens/Books";
import AddBooks from "./screens/AddBooks";
import EditBook from "./screens/EditBook";
import AddChapters from "./screens/AddChapters";
import Chapters from "./screens/Chapters";
import Topics from "./screens/Topics";
import AddTopics from "./screens/AddTopics";
import Questions from "./screens/Questions";
import AddQuestions from "./screens/AddQuestions";
import Schools from "./screens/Schools";
import AddSchools from "./screens/AddSchools";
import Subjects from "./screens/Subjects";
import StudyMaterial from "./screens/StudyMaterial";

// Sales App Routes
import SalesManagers from "./screens/SalesManagers";
import AddSalesManager from "./screens/AddSalesManager";
import ViewSalesManager from "./screens/ViewSalesManager";
import EditSalesManager from "./screens/EditSalesManager";
import SchoolsData from './screens/SchoolsData';
import AddSchoolData from './screens/AddSchoolData';
import EditSchoolData from './screens/EditSchoolData';
import SchoolEventsTimeline from './screens/SchoolEventsTimeline';
import DistributorEventsTimeline from './screens/DistributorEventsTimeline';
import Distributors from "./screens/Distributors";
import AddDistributor from "./screens/AddDistributor";
import EditDistributor from "./screens/EditDistributor";
import SalesDailyAttendanceReport from "./screens/SalesDailyAttendanceReport";
import SalesAttendanceReport from "./screens/SalesAttendanceReport";
import LeaveRequests from "./screens/LeaveRequests";

// ELP Routes
import Classes from './screens/Classes';
import AddElpChapters from './screens/AddElpChapters';
import ElpChapters from './screens/ElpChapters';
import ElpQuestions from './screens/ElpQuestions';
import AddElpQuestions from './screens/AddElpQuestions';
import AddClasses from './screens/AddClasses';
import EditClass from './screens/EditClass';

const ROUTES = [
  { path: "/home", roles: ["superadmin", "testgenerator_admin"], component: Home },
  { path: "/books", roles: ["superadmin", "testgenerator_admin"], component: Books },
  { path: "/addBooks", roles: ["superadmin", "testgenerator_admin"], component: AddBooks },
  { path: "/editBook/:bid", roles: ["superadmin", "testgenerator_admin"], component: EditBook },
  { path: "/addChapters", roles: ["superadmin", "testgenerator_admin"], component: AddChapters },
  { path: "/chapters", roles: ["superadmin", "testgenerator_admin"], component: Chapters },
  { path: "/topics", roles: ["superadmin", "testgenerator_admin"], component: Topics },
  { path: "/addTopics", roles: ["superadmin", "testgenerator_admin"], component: AddTopics },
  { path: "/questions", roles: ["superadmin", "testgenerator_admin"], component: Questions },
  { path: "/addQuestions", roles: ["superadmin", "testgenerator_admin"], component: AddQuestions },
  { path: "/schools", roles: ["superadmin", "testgenerator_admin"], component: Schools },
  { path: "/addSchools", roles: ["superadmin", "testgenerator_admin"], component: AddSchools },
  { path: "/subjects", roles: ["superadmin", "testgenerator_admin"], component: Subjects },
  { path: "/studyMaterial", roles: ["superadmin", "testgenerator_admin"], component: StudyMaterial },

  // Sales App Routes
  { path: "/salesManagers", roles: ["superadmin", "sales_admin"], component: SalesManagers },
  { path: "/addSalesManager", roles: ["superadmin", "sales_admin"], component: AddSalesManager },
  { path: "/viewSalesManager/:uuid", roles: ["superadmin", "sales_admin"], component: ViewSalesManager },
  { path: "/editSalesManager/:uuid", roles: ["superadmin", "sales_admin"], component: EditSalesManager },
  { path: "/schoolsData", roles: ["superadmin", "sales_admin"], component: SchoolsData },
  { path: "/addSchoolData", roles: ["superadmin", "sales_admin"], component: AddSchoolData },
  { path: "/editSchoolData/:uuid", roles: ["superadmin", "sales_admin"], component: EditSchoolData },
  { path: "/viewSchoolData/:uuid", roles: ["superadmin", "sales_admin"], component: SchoolEventsTimeline },
  { path: "/distributors", roles: ["superadmin", "sales_admin"], component: Distributors },
  { path: "/addDistributor", roles: ["superadmin", "sales_admin"], component: AddDistributor },
  { path: "/editDistributor/:uuid", roles: ["superadmin", "sales_admin"], component: EditDistributor },
  { path: "/viewDistributor/:uuid", roles: ["superadmin", "sales_admin"], component: DistributorEventsTimeline },
  { path: "/salesDailyReport", roles: ["superadmin", "sales_admin"], component: SalesDailyAttendanceReport },
  { path: "/salesReport", roles: ["superadmin", "sales_admin"], component: SalesAttendanceReport },
  { path: "/leaveRequests", roles: ["superadmin", "sales_admin"], component: LeaveRequests },

  // ELP Routes
  { path: "/addElpChapters", roles: ["superadmin", "elp_admin"], component: AddElpChapters },
  { path: "/elpChapters", roles: ["superadmin", "elp_admin"], component: ElpChapters },
  { path: "/classes", roles: ["superadmin", "elp_admin"], component: Classes },
  { path: "/elpQuestions", roles: ["superadmin", "elp_admin"], component: ElpQuestions },
  { path: "/addElpQuestions", roles: ["superadmin", "elp_admin"], component: AddElpQuestions },
  { path: "/addClasses", roles: ["superadmin", "elp_admin"], component: AddClasses },
  { path: "/editClass/:uuid", roles: ["superadmin", "elp_admin"], component: EditClass }
];

export default ROUTES;
